<template lang="pug">
b-modal#gamifyOperatorUpdate(
  ref="gamifyOperatorUpdate"
  :title="$t('ui.combine.gamify_update')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="id"
        type="text"
        v-model="gamify_id.toUpperCase()"
        :disabled="loading"
      )
    b-form-group(:label="$t('ui.token')").mb-0
      DebounceInput(
        size="sm"
        ref="token"
        required
        type="number"
        :dirty="$v.token.$dirty"
        :error="$v.token.$error"
        v-model.trim.lazy="$v.token.$model"
        :disabled="loading"
        keyPressRestrict="restrictOnlyNumber"
      )
      ValidateResult(:value="$v.token" :name="$t('ui.token')" :fvalue="'0'")
    b-form-group(:label="$t('ui.target_amount')").mb-0
      DebounceInput(
        size="sm"
        ref="target_amount"
        required
        type="number"
        :dirty="$v.target_amount.$dirty"
        :error="$v.target_amount.$error"
        v-model.trim.lazy="$v.target_amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.target_amount" :name="$t('ui.target_amount')" :fvalue="'0'")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    operatorID: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      gamify_id: '',
      token: '',
      target_amount: '',
    };
  },
  validations: {
    token: {
      required,
      mustMoreThan: function(value) {
        if(parseFloat(value) <= 0) return false
        return true
      }
    },
    target_amount: {
      required,
      mustMoreThan: function(value, vm) {
        if (vm.gamify_id === 'winlose') return true
        return parseFloat(value) > 0
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.gamifyOperatorUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          gamify_id: this.item.gamify_id,
          token: this.token,
          target_amount: this.target_amount
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.gamifyOperatorUpdate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  if(response.data.status == -9) {
                    this.$emit("failed", "combine.gamify_update", response.data.statusdesc);
                  } else {
                    this.$emit("failed", "combine.gamify_update", this.feedback.status);
                  }
                  this.$refs.gamifyOperatorUpdate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.gamify_id = this.item.gamify_id;
      this.token = this.item.token;
      this.target_amount = this.item.target_amount;
    }
  }
};
</script>